import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { Typography } from "../Typography/Typography";

export const StyledDiv = styled.div`
  ${FontStyle}
  ${BoxSizingStyle}

  ${tw`tw-relative tw-inline-block tw-max-w-full`}
`;

export const StyledSpan = styled(Typography)<{ $disabled?: boolean }>`
  visibility: hidden;
  display: block;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
  position: relative;
  border: 1px solid transparent;
  border-radius: 6px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  font-variant-numeric: tabular-nums;

  ${({ $disabled }) =>
    $disabled &&
    css`
      visibility: visible;
    `}

  &:empty:before {
    content: " ";
  }
`;

StyledSpan.displayName = "StyledSpan";

export const StyledInput = styled(Typography)`
  ${tw`
    tw-absolute
    tw-inset-0
    tw-border
    tw-border-transparent
    tw-border-solid
    hover:tw-border-theme-700
    focus-within:tw-border-theme-700
    tw-rounded-md
    tw-box-border
    tw-overflow-hidden
    tw-whitespace-nowrap
    focus-within:tw-overflow-scroll
    tw-w-full`}

  background-color: inherit;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
  &:focus-whitin {
    text-overflow: clip;
  }
  outline-width: 0px;
  outline: none;
  &:disabled {
    opacity: 0;
  }
`;

StyledInput.displayName = "StyledInput";
